import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import DialogComponent from '../../../beta/layouts/DialogComponent';
import { useUser } from '../../../context/UserContext';

const SubscriberCustomer = ({backgroundColor = '#5D3B9E', footer = '', customerObj = {}}) => {
    const [stripeInfo, setStripeInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const authCtx = useUser();
    const colorScheme = {
        background75: `rgba(${parseInt(backgroundColor.slice(1, 3), 16)}, ${parseInt(backgroundColor.slice(3, 5), 16)}, ${parseInt(backgroundColor.slice(5, 7), 16)}, 0.75)`,
        background50: `rgba(${parseInt(backgroundColor.slice(1, 3), 16)}, ${parseInt(backgroundColor.slice(3, 5), 16)}, ${parseInt(backgroundColor.slice(5, 7), 16)}, 0.5)`,
        background25: `rgba(${parseInt(backgroundColor.slice(1, 3), 16)}, ${parseInt(backgroundColor.slice(3, 5), 16)}, ${parseInt(backgroundColor.slice(5, 7), 16)}, 0.25)`
    };

    useEffect(() => {
        const fetchCustomerData = async () => {
            const response = await fetch(`${apiUrl}/stripe/customer/${customerObj['customer']}?token=${authCtx.token}`);
            const res = await response.json();
            console.log(res);
            setStripeInfo(res);
            setLoading(false);
        };
        fetchCustomerData();
    }, [customerObj]);

  return (
    <DialogComponent footer={footer} maxHeight='60vh'>
        <Grid container style={{height: '100%', marginTop: '8px', paddingLeft: '16px'}} spacing={2}>
            {loading ? (
                <Typography>Loading customer data...</Typography>
            ) : (
                <React.Fragment>
                    <Grid item xs={12}>
                        <Typography>{`Name: ${stripeInfo['name']}`}</Typography>
                        <Typography>{`Address: ${stripeInfo['address']['line1']}${` ${stripeInfo['address']['line2'] ?? ''}`}, ${stripeInfo['address']['postal_code']} ${stripeInfo['address']['city']} ${stripeInfo['address']['state']}, ${stripeInfo['address']['country']}`}</Typography>
                        <Typography>{`Balance: ${stripeInfo['balance']}`}</Typography>
                        <Typography>{`Created: ${stripeInfo['created']}`}</Typography>
                        <Typography>{`Currency: ${stripeInfo['currency']}`}</Typography>
                        <Typography>{`Discount: ${stripeInfo['discount']}`}</Typography>
                        <Typography>{`Description: ${stripeInfo['description']}`}</Typography>
                        <Typography>{`Invoice Settings: ${stripeInfo['invoice_settings']['custom_fields']}, ${stripeInfo['invoice_settings']['default_payment_method']}, ${stripeInfo['invoice_settings']['footer']}, ${stripeInfo['invoice_settings']['rendering_options']}`}</Typography>
                        <Typography>{`Phone: ${stripeInfo['phone']}`}</Typography>
                        <Typography>{`Tax Exempt: ${stripeInfo['tax_exempt']}`}</Typography>
                    </Grid>
                </React.Fragment>
            )}
        </Grid>
    </DialogComponent>
  );
};

export default SubscriberCustomer;